import { inputStreamSourceConfig } from "@arrowsup/platform-dtos";
import { AdAccountInput } from "../../../ad-platforms/ad-account-input";

const platform = inputStreamSourceConfig["google-lsa-lead"].adAccount;

export const GoogleLsaSourceConfig: React.FC = () =>
  platform ? <AdAccountInput platform={platform} /> : null;
